var _style, _defs, _rect, _rect2, _path, _rect3, _g, _circle, _path2, _path3, _rect4, _circle2, _circle3, _circle4, _g2, _g3, _rect5, _circle5, _path4, _circle6, _g4, _rect6, _g5, _path5, _g6, _rect7, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 520,
    height: 400,
    viewBox: "0 0 520 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{opacity:.5}.C{fill:#fff}.D{fill:#b4bed5}.E{fill-rule:nonzero}.F{opacity:.53}.G{opacity:.45}.H{stroke:#b4bed5}.I{opacity:.3}.J{fill:#7f93bc}.K{fill:#f4674c}.L{fill:#e9edf2}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-54.2361057%",
    x2: "50%",
    y2: "121.975041%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4674c",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-36.5026521%",
    y1: "49.9785592%",
    x2: "97.5397811%",
    y2: "49.9785592%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4674c",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-36.5026521%",
    y1: "50%",
    x2: "97.5397811%",
    y2: "50%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4674c",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M229 251.44a2.26 2.26 0 0 0-2.26 2.26v27.52a2.26 2.26 0 0 0 2.26 2.26h.44v-32l-.44-.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#cdd4e2",
    x: -0.28,
    y: 0.77,
    width: 207.96,
    height: 400,
    rx: 26.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.01,
    y: 11.47,
    width: 187.37,
    height: 377.28,
    rx: 18.32,
    className: "C"
  })), /*#__PURE__*/React.createElement("g", {
    className: "D"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.29,
    y: 24.18,
    width: 55.31,
    height: 6.3,
    rx: 3.15,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.84,
    y: 24.18,
    width: 33.72,
    height: 6.3,
    rx: 3.15,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.52 382.25H80.8a2.12 2.12 0 1 1 0-4.24h47.73a2.12 2.12 0 1 1 0 4.24",
    fill: "#d7dde9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#A)",
    x: 19.36,
    y: 89.32,
    width: 169.46,
    height: 129.01,
    rx: 11.05
  }))), /*#__PURE__*/React.createElement("image", {
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    x: 10,
    y: 79,
    width: 190,
    height: 150,
    xlinkHref: "data:image/png;base64,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",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e5e9f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.29,
    y: 94.25,
    width: 159.61,
    height: 119.16,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.29,
    y: 227.63,
    width: 159.61,
    height: 66.19,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.29,
    y: 357.91,
    width: 159.61,
    height: 12.58,
    rx: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.22,
    y: 49.3,
    width: 73.68,
    height: 30.66,
    rx: 6.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.29,
    y: 49.3,
    width: 73.68,
    height: 30.66,
    rx: 6.05
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    className: "D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.97,
    cy: 113.89,
    r: 10.37,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.48 108.2h100.75v3.22H63.48zm0 8.16h66.9v3.22h-66.9z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "G"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 132.9h159.6",
    style: {
      mixBlendMode: "multiply"
    },
    className: "H I"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    className: "D E"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.97,
    cy: 153.89,
    r: 10.37,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.48 148.2h85.36v3.22H63.48zm0 8.15h54.83v3.22H63.48z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 175.05h159.6",
    style: {
      mixBlendMode: "multiply"
    },
    className: "H I"
  }), /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    className: "D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.97,
    cy: 193.71,
    r: 10.37,
    style: {
      mixBlendMode: "multiply"
    },
    className: "F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.48 188.03h93.6v3.22h-93.6zm0 8.15h53.8v3.22h-53.8z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "G"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.7,
    cy: 213.41,
    r: 30.04,
    className: "K"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.54 229.4H98.9a4.37 4.37 0 0 1-3.09-1.28L89 221.3a4.31 4.31 0 0 1-1.28-3.09v-9.63A4.31 4.31 0 0 1 89 205.5l6.8-6.82a4.36 4.36 0 0 1 3.09-1.27h9.64a4.36 4.36 0 0 1 3.09 1.27l6.8 6.82a4.31 4.31 0 0 1 1.28 3.09v9.63a4.31 4.31 0 0 1-1.28 3.09l-6.8 6.82a4.37 4.37 0 0 1-3.09 1.28zm-9.64-29.1a1.47 1.47 0 0 0-1 .42l-6.8 6.82a1.45 1.45 0 0 0-.42 1v9.63a1.45 1.45 0 0 0 .42 1l6.8 6.82a1.47 1.47 0 0 0 1 .42h9.64a1.47 1.47 0 0 0 1-.42l6.8-6.82a1.46 1.46 0 0 0 .43-1v-9.63a1.46 1.46 0 0 0-.43-1l-6.8-6.82a1.47 1.47 0 0 0-1-.42H98.9z",
    className: "C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.72 221.7a2.18 2.18 0 1 1 2.18-2.18 2.19 2.19 0 0 1-2.18 2.18zm-.72-7.27h-1.45v-9.32h4.36v6.4a2.91 2.91 0 0 1-2.91 2.91z",
    className: "C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 226.72,
    y: 0.77,
    width: 292.95,
    height: 144.77,
    rx: 6.05,
    className: "C E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.04 77.42h265.24m-265.24 8.2h265.24m-265.24 8.2h265.24M240.04 102h265.24m-265.24 8.2h265.24m-265.24 8.2h265.24m-265.24 8.2h265.24m-265.24 8.2h265.24",
    style: {
      mixBlendMode: "multiply"
    },
    strokeWidth: 0.5,
    className: "F H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffa232",
    cx: 374.17,
    cy: 60.34,
    r: 4.86
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384 58.74h19.1v3.2h-19.05z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "D F"
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#09f",
    cx: 424.6,
    cy: 60.34,
    r: 4.86
  })), /*#__PURE__*/React.createElement("path", {
    d: "M453.76 61.94H434.7l-.05-3.2h19.1z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "D F"
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#32cb82",
    cx: 475.12,
    cy: 60.34,
    r: 4.86
  })), /*#__PURE__*/React.createElement("path", {
    d: "M504.32 61.94h-19.05l-.05-3.2h19.1z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "D F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.12 106.33s58.65 32.3 88.15 25.48c19.66-4.54 49.3-60.34 76-55.08 6.14 1.2 11.3 1.6 57.26 44.45 10.25 9.56 17.5 14.4 43.87 10.63",
    stroke: "#ffa232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.12 133s53.55 2.77 88.15-1.14c11.45-1.3 33.38-28.87 44.36-29.46 12.25-.65 13.63 3.6 36.45 21 0 0 11.92 10.53 40.9 9.33",
    stroke: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08 125.34s67.92 9 130.27 7.6c31.45-.7 125.82 0 125.82 0h10.2",
    stroke: "#32cb82"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.87,
    y: 11.21,
    width: 77.9,
    height: 25.93,
    rx: 3.21,
    className: "L"
  }), /*#__PURE__*/React.createElement("g", {
    className: "J"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 252.75,
    cy: 24.18,
    r: 4.19,
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.63 23.06h27.57v2.23h-27.53zm36.3 0h13.77v2.23h-13.75z",
    className: "B"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 327.05,
    y: 11.49,
    width: 77.9,
    height: 25.93,
    rx: 3.21,
    className: "L"
  }), /*#__PURE__*/React.createElement("g", {
    className: "J"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.93,
    cy: 24.46,
    r: 4.19,
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.85 23.34h16.45v2.24h-16.45zm36.25 0h13.78v2.24h-13.75z",
    className: "B"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 413.23,
    y: 11.49,
    width: 92.3,
    height: 25.93,
    rx: 3.21,
    className: "L"
  }), /*#__PURE__*/React.createElement("g", {
    className: "J"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.12,
    cy: 24.46,
    r: 4.19,
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 23.34h37.05v2.24h-37.02zm50.7 0h13.78v2.24H483.7z",
    className: "B"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M10 302.84h177.22v46.64H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M10 326.15h177.22v23.32H10z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.33 322.5h30.2l.1 7.6h-30.2zm43 0h65.3l.1 7.6h-65.3z",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.5 322.5h48.8l.1 7.6h-48.8zm40.7-19.4h95.82v7.6H391.3z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9 303.1h43.06l.08 7.6H336.9z",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9 341.87h125.8l.1 7.6H336.9z",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.25 184.55H423l.1 7.6h-92.74zm110.1 0h79.37v7.6h-79.26z",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 184.55h86.43l.12 7.6H227.5z",
    className: "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 224.8h144.7v7.6H375.1zm-44.26 0h27.54l.04 7.6h-27.54z",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 224.8h86.43l.12 7.6H227.5zm77.37-60.37h150.98v7.6H305z",
    className: "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 164.43h60.66l.1 7.6H227.5z",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.3 204.67h82.37l.1 7.6h-82.36z",
    className: "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5 204.67h148.32l.1 7.6H227.5z",
    className: "B"
  }))))), /*#__PURE__*/React.createElement("image", {
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    x: 143,
    y: 287,
    width: 190,
    height: 78,
    xlinkHref: "data:image/png;base64,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",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#e5e9f1",
    x: 157.06,
    y: 302.84,
    width: 159.61,
    height: 46.64,
    rx: 6.05
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.36,
    cy: 326.15,
    r: 12.62,
    className: "K"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.25 321.2l-1.92-1.93-4.97 4.97-4.97-4.97-1.93 1.93 4.97 4.96-4.97 4.98 1.93 1.92 4.97-4.97 4.97 4.97 1.92-1.92-4.97-4.98z",
    className: "C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.1 319.23h90v3.92h-90zm0 9.93h51.98v3.92H203.1z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "G D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#32cb82",
    cx: 315.11,
    cy: 326.15,
    r: 12.62
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.56 322.1l-1.65-1.65a.6.6 0 0 0-.83 0l-7.08 7.32-3.07-3a.59.59 0 0 0-.82 0l-1.46 1.45a.58.58 0 0 0 0 .81l4.9 4.85a.62.62 0 0 0 .49.16.61.61 0 0 0 .48-.16l9-8.94a.59.59 0 0 0 .05-.84z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.42 251.44h-288v32h288a2.26 2.26 0 0 0 2.26-2.26V253.7a2.26 2.26 0 0 0-2.26-2.26z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 235.86,
    y: 258.44,
    width: 38.66,
    height: 9.12,
    rx: 2,
    className: "B J"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.07,
    cy: 263,
    r: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18 262.28h25.38v1.45h-25.38z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.03 261.6h96.07v2.82h-96.07z",
    className: "D"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#32adff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.86 273.66h96.07v2.82h-96.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 273.29,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 268.17,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 263.06,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#d2e6f8",
    x: 406.16,
    y: 257.94,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M438.38 275.75s11.32.46 15.06 0 3.44-.86 8.93-12.15c0 0 2.58-4.74 5.9-5.06 0 0 3.55-.75 9 6.35a47.09 47.09 0 0 0 5.93 5.18s6.9 4.88 15 5.68",
    strokeWidth: 2.5,
    style: {
      mixBlendMode: "multiply"
    },
    className: "G H"
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "E"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.72,
    y: 368.47,
    width: 292.95,
    height: 32.04,
    rx: 2.29,
    className: "C"
  }), /*#__PURE__*/React.createElement("g", {
    className: "K"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    y: 117.03
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.86,
    y: 375.47,
    width: 38.66,
    height: 9.12,
    rx: 2,
    className: "B J"
  }), /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.07,
    cy: 380.03,
    r: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18 379.3h25.38v1.45h-25.38z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.03 378.62h96.07v2.82h-96.07z",
    className: "D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#32adff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.86 390.7h96.07v2.82h-96.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 390.32,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 385.2,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d2e6f8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 380.08,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.16,
    y: 374.96,
    width: 8.12,
    height: 3.69,
    rx: 0.22
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M438.38 392.78h15.06s5.54-.13 8.93-6.25c0 0 2.58-4.73 5.9-5 0 0 3.55-.76 9 6.34a12.63 12.63 0 0 0 5.93 4.2c3.57 1.14 15 .76 15 .76",
    strokeWidth: 2.5,
    style: {
      mixBlendMode: "multiply"
    },
    className: "G H"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider3);
export default __webpack_public_path__ + "static/media/slider-3.328c6c58a47d1bf3a63e906de78a8059.svg";
export { ForwardRef as ReactComponent };